import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis';
import axios from 'axios';

export const getMoOrders = createAsyncThunk('getMoOrders', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/get-orders`;
  try {
    const response = await axios.post(URL, data);
    return response;
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue);
  }
});

export const createMoOrder = createAsyncThunk('createMoOrder', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/create`;
  try {
    const response = await axios.post(URL, data);
    return response;
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue);
  }
});

export const createBulkFabricMO = createAsyncThunk('createBulkFabricMO', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/bulk-create`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue);
    }
});



export const downloadBulkCreateSample = createAsyncThunk('downloadBulkCreateSample', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/download-bulk-create-sample`
    try {
        let bodyFormData = new FormData();
        const response = await axios.get(URL, { headers: { "Content-Type": "multipart/form-data" }, 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'sample_bulk_create_mo.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadAllocateFabricInventory = createAsyncThunk('downloadAllocateFabricInventory', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/download-fabric-allocation-sample`
    try {
        const response = await axios.get(URL, { redirect: 'follow', headers: { "Content-Type": "multipart/form-data" }, 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'sample_mo_fabric_allocation.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const allocateFabricInventory = createAsyncThunk('allocateFabricInventory', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/allocate-farbic-inventory`
    try {
        let bodyFormData = new FormData();
        bodyFormData.append('file', data)
        const response = await axios.post(URL, bodyFormData, { headers: { "Content-Type": "multipart/form-data" }, 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'allocated_fabric_inventory.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

